export const uk = {
    'normal-view-title': 'Добавьте второй заголовок в объявления',
    'normal-view-title-hint': 'Показывается, потому что у вас есть объявления без второго заголовка',
    'percent-value': '{value}%',
    'popup-view-title': 'Добавьте второй заголовок в объявление',
    'popup-view-title-hint': 'Показывается, потому что у объявления нет второго заголовка',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления',
    'title-extension-desc1':
        'По нашим данным CTR объявлений со вторым заголовком улучшается на {desktopValue} на десктопах и на {mobileValue} на мобильных устройствах.',
    'title-extension-desc2':
        'Используйте второй заголовок, чтобы сообщить пользователю больше информации о вашем предложении. Второй заголовок показывается не всегда, поэтому проверьте, что объявление не теряет смысл и связность без него.'
};
